export default function ErrorPage({ message }: { message: string }) {
  return <div>{message}</div>;
}
